module.exports = __webpack_public_path__ + "img/gun.2b0ce099.svg";